import {Parser} from 'htmlparser2';

const allowedAttributes = ['class', 'data-width', 'data-color', 'data-aligned', 'data-id', 'data-version', 'data-tasks', 'data-filter', 'data-input-parameters', 'data-size'];

const isGrid = attributes => {
  const classList = attributes.hasOwnProperty('class') ? attributes.class.split(/\s+/) : [];
  return classList.includes('grid');
};

const isColumn = attributes => {
  const classList = attributes.hasOwnProperty('class') ? attributes.class.split(/\s+/) : [];
  return classList.includes('column');
};

export const markdownHtmlGrid = md => {
  md.block.ruler.before('html_block', 'html_grid',
      (state, startLine, endLine) => {
        let nextLine, lineText,
            pos = state.bMarks[startLine] + state.tShift[startLine],
            max = state.eMarks[startLine];

        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[startLine] - state.blkIndent >= 4) {
          return false;
        }

        if (state.src.charCodeAt(pos) !== 0x3C /* < */ || pos + 2 >= max) {
          return false;
        }

        if (state.src.slice(pos + 1, pos + 4).toLowerCase() !== 'div') {
          return false;
        }

        let gridEndIndex;
        let gridLevel = 0;
        let gridColumnLevel = 0;
        const divAttributesStack = [];
        let cellText = '';
        const tokenStack = [];

        const parser = new Parser({
          onopentag(name, attributes, isImplied) {
            if (name === 'div') {
              divAttributesStack.push(attributes);
              const grid = isGrid(attributes);
              const column = isColumn(attributes);

              if (grid) {
                gridLevel++;
              } else if (column) {
                gridColumnLevel++;
              }

              if (gridLevel === 1 && grid) {
                tokenStack.push(new state.Token('grid_open', '', 1));
                return;
              } else if (gridColumnLevel === 1 && column) {
                const token = new state.Token('grid_column_open', '', 1);
                token.attrs = Object.keys(attributes).
                filter(attribute => allowedAttributes &&
                    allowedAttributes.includes(attribute)).
                map(attribute => [attribute, attributes[attribute]]);
                tokenStack.push(token);
                return;
              }
            }

            cellText += `<${name}${Object.keys(attributes).
            filter(attribute => allowedAttributes &&
                allowedAttributes.includes(attribute)).
            map(attribute => [` ${attribute}="${attributes[attribute]}"`]).
            join('')}>`;
          },
          ontext(text) {
            cellText += text;
          },
          onclosetag(name, isImplied) {
            if (name === 'div') {
              const attributes = divAttributesStack.pop();
              const grid = isGrid(attributes);
              const column = isColumn(attributes);

              if (grid) {
                gridLevel--;
              } else if (column) {
                gridColumnLevel--;
              }

              if (gridLevel === 0 && grid) {
                tokenStack.push(new state.Token('grid_close', '', -1));
                gridEndIndex = parser.endIndex;
                return;
              } else if (gridColumnLevel === 0 && column) {
                state.md.block.parse(cellText.trim(), state.md, state.env,
                    tokenStack);
                tokenStack.push(new state.Token('grid_column_close', '', -1));
                cellText = '';
                return;
              }
            }

            cellText += `</${name}>`;
          },
        });

        lineText = state.src.slice(pos, max);

        parser.write(lineText);

        nextLine = startLine + 1;

        for (; nextLine < endLine; nextLine++) {
          pos = state.bMarks[nextLine] + state.tShift[nextLine];
          max = state.eMarks[nextLine];

          lineText = state.src.slice(pos, max);
          cellText += '\n';

          parser.write(lineText);

          if (gridEndIndex) {
            if (lineText.length !== 0) {
              nextLine++;
            }

            break;
          }
        }

        if (!gridEndIndex) {
          return false;
        }

        state.line = nextLine;

        tokenStack.forEach(tok => state.tokens.push(tok));

        return true;
      });
};